// extracted by mini-css-extract-plugin
export default {"orderDetail":"OrderDetail_orderDetail__hguiH","issueHeader":"OrderDetail_issueHeader__gIGyc","issueFooter":"OrderDetail_issueFooter__aoLwr"};